module.exports = __webpack_public_path__ + "img/userimage.2f4b8d8d.jpg";